if (!customElements.get('colors-component')) {
    customElements.define('colors-component', class ColorsComponent extends HTMLElement {
    constructor() {      
      super();      
      var ethis= this;
      this.colorContainerComp = this.querySelector('.phone_colors_container');      
      this.colorContainerComp.addEventListener('mousedown', this.onButtonClick.bind(this));
      this.customiser  = this.closest('.section').querySelector('dyefor-customizer');
      this.resetColors();
      
     // this.closest('.product__info-container').querySelector('variant-selects').addEventListener('change', () => ethis.resetColors());

    }
     connectedCallback() {
       this.resetColors();
     }
    getSelectedColor(){
      return $(this.colorContainerComp.querySelector('.phone-selected')).data("clr");
    }    
    getSelectedCstInfo(){
      return this.colorContainerComp.crt_selCstInfo;
    }
    getVariantCstData(ssku) {
      var ret = null;
      if(typeof(cstData) == 'undefined' || !cstData) return ret;
      var fnd = cstData.find(x => x.variant === ssku);
      if (fnd) {
          ret = { cst: fnd, img: [] }
          fnd.Pictures.forEach(function (a) {
              if (a.imgalt == null) {
                  return;
              }
              var ss = a.imgalt.toLowerCase();//a.OverridePreview ? "clear " + a.imgalt.toLowerCase() : a.imgalt.toLowerCase();
              var pif = allPict[ss];
              if (pif) {
                  var oe = ret.img.find(x=>x.img.index == pif.index);
                  if (oe == null)
                      ret.img.push({ mock: a.image, img: pif, useForCst: a.UseForCustomizer });
              }
          });
      }
      return ret;
  	}
    replaceAllInString(str, search, replacement) {
        var target = str;
        return target.replace(new RegExp(search, 'g'), replacement);
    }
    updateColors(variant,product){
      if(typeof(allVarImg) == 'undefined' || !allVarImg) return;
       // build colors from variant
      var skutrim = variant.sku.substring(0, variant.sku.indexOf('-'));
      var crt_selCstInfo = this.getVariantCstData(skutrim);
      this.colorContainerComp.crt_selCstInfo = crt_selCstInfo;
      if(!allVarImg[variant.id]){
        InitAllVars();
      }
      var vi = allVarImg[variant.id];
      
      var allClrs = [];
      for (var ix in vi) {
          if (vi[ix].constructor !== Array) {
              continue;
          }
          var e = vi[ix][0];
          if (allClrs.indexOf(e) == -1) {
              allClrs.push(e);
          }
      }
      if (activePhoneColor == null || activePhoneColor.length == 0) {
          if (allClrs.length > 0) {
              activePhoneColor = allClrs[0].toLowerCase();
          }
      } else {
          if (allClrs.indexOf(activePhoneColor) == -1) {
              activePhoneColor = "";
              if (allClrs.length > 0) {
                  activePhoneColor = allClrs[0].toLowerCase();
              }
          } else {
              if (allClrs.length == 0) {
                  activePhoneColor = "";
              }
          }
      }

      if (activePhoneColor == null) activePhoneColor = "";
      
      var cc = $(".phone_colors_container").empty();
      var classList = cc[0].className.split(/\s+/);
      var toRem = "";
      for (var i = 0; i < classList.length; i++) {
          if (classList[i].indexOf('_color_scheme') != -1) {
              toRem += " " + classList[i];
          }
      }
      cc.removeClass(toRem);
      cc.addClass(this.replaceAllInString(
                    this.replaceAllInString(variant.option1.toLowerCase().trim(), "/", "")
                   , /[^a-zA-Z0-9]/g, "_") + "_color_scheme");
	  var ethis= this;
      //if(replace_src == null)
      {
          for (var ix in allClrs) {
              var c = allClrs[ix];
              var cSel = activePhoneColor == c ? "phone-selected" : "";
              cc.append($("<div>").addClass("phone_color").addClass(cSel).addClass(c + "_phone_color").attr("data-clr", c).click(function () {
                  var ct = $(this).attr("data-clr");
                  if (activePhoneColor == ct)
                      return;
                  $(ethis.colorItems).removeClass("phone-selected");
                  $(this).addClass("phone-selected");
                  activePhoneColor = ct;
                  //changeColors(variant, $product, null);
              }));
          }
      }
      this.colorItems = this.querySelectorAll('.phone_color');
      if ((typeof(hide_render_swatches) != 'undefined' &&  hide_render_swatches) || allClrs.length <= 1) {
          cc.hide();
      } else {
          cc.show();
      }
    }
    resetColors() {
      this.colorItems = this.querySelectorAll('.phone_color');
      return;
      var variant = this.customiser.findSelectedVariant();
      var product = this.customiser.findProduct();
     

    }
  	onButtonClick(event) {
    //event.preventDefault();
    //console.log(event);            
      let outher = this;
     this.dispatchEvent(new Event('change'));
      setTimeout(function(){
      	outher.customiser.refreshImage();
      },100);
    }
  })
}

//customElements.define('colors-component', ColorsComponent);